import { User } from 'lib-shared-types-api';
import { useMemo } from 'react';

import { useAppSelector } from 'utils/redux/useAppSelector';

type UseCurrentUserResult = {
  /** The current user. */
  readonly user: User;
};

/** A hook for getting various information on the currently logged in user. */
export const useCurrentUser = (): UseCurrentUserResult => {
  const user = useAppSelector((state) => state.settings.profile.profile);

  return useMemo(() => ({ user }), [user]);
};
